<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body">

          <div class="vx-row no-gutter justify-center items-center">

            <!--
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
            </div>
            -->

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="px-8 pt-8 login-tabs-container">

                <div class="vx-card__title mb-4">
                  <img src="@/assets/images/logo/JustTapLogo.png" class="center mb-12 mt-6" style="max-width:50%" />
                  <h4 class="mb-4">Forgot your password?</h4>
                  <p>Enter your account email below and we'll send you an email to reset your password.</p>
                </div>
                <div>
                <vs-input
                    v-validate="'required|email|min:3'"
                    data-vv-validate-on="blur"
                    name="email"
                    icon-no-border
                    icon="icon icon-user"
                    icon-pack="feather"
                    label-placeholder="Email"
                    v-model="email"
                    class="w-full"/>
                <span class="text-danger text-sm">{{ errors.first('email') }}</span>

                <vs-button  type="border mt-6" @click="$router.push('/login')">Back to Login</vs-button>
                <vs-button class="float-right mt-6" :disabled="!validateForm" @click="sendPasswordResetEmail">Send</vs-button>

              </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      email: ''
    }
  },
  computed: {
    validateForm () {
      return this.email !== ''
    }
  },
  methods: {
    sendPasswordResetEmail () {
      this.$fauth.sendPasswordResetEmail(this.email).then(() => {
        this.$vs.notify({
          title: 'Email Sent',
          text: 'A password reset email has been sent - please follow the link from the email',
          iconPack: 'feather',
          icon: 'icon-check-circle',
          color: 'success',
          position: 'top-center'
        })
        this.logout()
      }).catch(error => {
        console.log(error)
      })
    }
  }
}

</script>


<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook { background-color: #1551b1 }
    .bg-twitter { background-color: #00aaff }
    .bg-google { background-color: #4285F4 }
    .bg-github { background-color: #333 }
  }
}
</style>
